<template>
  <b-modal
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      @hidden="handleHidden"
  >
    <div class="text-center py-2">
      <div class="success-icon mx-auto mb-3">
        <i class="bx bx-check"></i>
      </div>
      <h4 class="mb-2">{{ successTitle }}</h4>
      <p class="mb-0" v-if="successMessage">{{ successMessage }}</p>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-end gap-2 w-100">
        <b-button
            block
            variant="light"
            @click="handleCancel"
        >
          <b>{{ $t('Cancel') }}</b>
        </b-button>
        <b-button
            block
            class="m-0"
            variant="primary"
            @click="handleConfirm"
        >
          <b>{{ lodash.startCase($t('sales_plans.buttons.yes_continue')) }}</b>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'sales-plan-publish-confirmation',
  props: {
    id: {
      default: 'sales-plan-publish-confirmation-modal',
    },
  },
  data() {
    return {
      options: {
        title: null,
        message: null,
      },
      resolvePromise: null,
    };
  },
  computed: {
    successTitle() {
      return this.options.title || `${this.$t('Success')}!`;
    },
    successMessage() {
      return this.options.message || '';
    },
  },
  methods: {
    show(options = {}) {
      return new Promise((resolve) => {
        this.options = {
          title: null,
          message: null,
          ...options,
        };
        this.resolvePromise = resolve;
        this.$bvModal.show(this.id);
      });
    },
    handleConfirm() {
      this.$emit('confirm')
      this.$bvModal.hide(this.id);
    },
    handleCancel() {
      this.$emit('cancel')
      this.$bvModal.hide(this.id);
    },
    handleHidden() {
      this.$emit('hidden');
      if (this.resolvePromise) {
        this.resolvePromise(true);
        this.resolvePromise = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.success-icon {
  align-items: center;
  background: rgba(25, 135, 84, 0.12);
  border-radius: 999px;
  color: #198754;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  width: 40px;

  i {
    font-size: 40px;
    line-height: 1;
  }
}

::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }

  .close-action-btn {
    background-color: #f2f4f7;
    border-color: #f2f4f7;
    color: #344054;
  }
}
</style>
